var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "registration" }, [
    _c("div", [
      _c(
        "div",
        { staticClass: "flex registration-service" },
        [
          _vm.withDiscovery
            ? _c(
                "md-card",
                { staticClass: "service-card demo-card" },
                [
                  _c("md-card-header", [
                    _c("h2", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("registration.service-discovery")
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-content",
                    { staticClass: "service-card-content" },
                    [
                      _c("div", { staticClass: "service-card-subtitle" }, [
                        _c("div", {
                          staticClass: "primary-text",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("registration.service-demo-description", {
                                days: _vm.days
                              })
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "sub-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "registration.service-demo-description-precision"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "service-card-icon" }, [
                        _c("img", { attrs: { src: "/imgs/loupe.svg" } })
                      ]),
                      _vm._v(" "),
                      _c("submit-button", {
                        staticClass:
                          "md-raised md-primary md-theme-default registration-standalone-button",
                        attrs: {
                          label: _vm.$t("registration.service-discover"),
                          submitting: _vm.submittingDiscovery,
                          disabled: _vm.isSubmiting
                        },
                        on: {
                          click: function($event) {
                            _vm.submit("demo")
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "md-card",
            { staticClass: "service-card with-billing-card" },
            [
              _c("md-card-header", [
                _c("h2", [_vm._v(_vm._s(_vm.$t("registration.service-join")))]),
                _vm._v(" "),
                _c("div", { staticClass: "service-card-subtitle" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("registration.service-join-subscription")) +
                      "\n                    "
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.withBilling
                ? _c(
                    "md-card-content",
                    {
                      staticClass: "service-card-content",
                      staticStyle: { height: "100%" }
                    },
                    [
                      _c("div", { staticClass: "service-card-content-split" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "service-card-element service-card-border"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "service-card-subtitle" },
                              [
                                _c("div", { staticClass: "primary-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("registration.service-join-now")
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "sub-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "registration.service-join-now-precision"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "service-card-icon" }, [
                              _c("img", { attrs: { src: "/imgs/cb.svg" } })
                            ]),
                            _vm._v(" "),
                            _c("submit-button", {
                              staticClass:
                                "md-raised md-primary md-theme-default registration-standalone-button",
                              attrs: {
                                label: _vm.$t("registration.service-pay-now"),
                                submitting: _vm.submittingPayNow,
                                disabled: _vm.isSubmiting
                              },
                              on: {
                                click: function($event) {
                                  _vm.submit("payment")
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "service-card-element" },
                          [
                            _c(
                              "div",
                              { staticClass: "service-card-subtitle" },
                              [
                                _c("div", {
                                  staticClass: "primary-text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("registration.service-join-bill")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "sub-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "registration.service-join-bill-precision"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "service-card-icon" }, [
                              _c("img", { attrs: { src: "/imgs/billing.svg" } })
                            ]),
                            _vm._v(" "),
                            _c("submit-button", {
                              staticClass:
                                "md-raised md-primary md-theme-default registration-standalone-button",
                              attrs: {
                                label: _vm.$t("registration.service-pay-bill"),
                                submitting: _vm.submittingPayBill,
                                disabled: _vm.isSubmiting
                              },
                              on: {
                                click: function($event) {
                                  _vm.submit("bill")
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _c(
                    "md-card-content",
                    { staticClass: "service-card-content" },
                    [
                      _c("div", { staticClass: "service-card-subtitle" }, [
                        _c("div", { staticClass: "primary-text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("registration.service-join-now"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "sub-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("registration.service-join-now-precision")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "service-card-icon" }, [
                        _c("img", { attrs: { src: "/imgs/cb.svg" } })
                      ]),
                      _vm._v(" "),
                      _c("submit-button", {
                        staticClass:
                          "md-raised md-primary md-theme-default registration-standalone-button",
                        attrs: {
                          label: _vm.$t("registration.service-pay-now"),
                          submitting: _vm.submittingPayNow,
                          disabled: _vm.isSubmiting
                        },
                        on: {
                          click: function($event) {
                            _vm.submit("payment")
                          }
                        }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c("span", {
            staticClass: "hint-text select-service-hint",
            domProps: { innerHTML: _vm._s(_vm.getPrice) }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6350365a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6350365a","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/SelectServiceComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6350365a","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/SelectServiceComponent.vue
// module chunks = 1 2 3